<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-checkbox v-model="data.allow_student_counselor">{{
        $t("communication.also_send_to_students_counselor")
      }}</md-checkbox>
    </div>
    <div class="md-layout-item md-size-25 md-small-size-100" v-if="hasCheckBox">
      <md-checkbox v-model="data.allow_student_family">{{
        $t("communication.also_send_to_students_family")
      }}</md-checkbox>
    </div>
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.filter_by") }}</label>
        <md-select
          @md-selected="getListOptions"
          name="target"
          v-model="data.filter_by"
          id="target"
        >
          <md-option value="Grade">{{ $t("common.grade") }}</md-option>
          <md-option value="Class">{{ $t("common.class") }}</md-option>
          <md-option value="Term">{{ $t("common.term") }}</md-option>
          <md-option value="Program">{{ $t("common.program") }}</md-option>
          <md-option value="Student">
            {{ $t("communication.student_name_student_id") }}
          </md-option>
        </md-select>
      </md-field>
    </div>
    <div
      v-if="data.filter_by === 'Grade'"
      class="md-layout-item md-size-25 md-small-size-100"
    >
      <md-field>
        <label>{{ $t("communication.student_grade") }}</label>
        <md-select
          name="target"
          multiple
          v-model="data.selectedList"
          id="target"
        >
          <md-option
            :value="grade.name"
            v-for="(grade, gradeIndex) in gradeList"
            :key="gradeIndex"
            >{{ grade.name }}</md-option
          >
        </md-select>
      </md-field>
    </div>
    <div
      v-else
      class="md-layout-item md-size-25 md-small-size-100"
      :key="selectedIndex"
    >
      <selection-component
        v-if="data.filter_by"
        :label="data.filter_by"
        :data-list="dataList"
        :display-field="displayField"
        :track-by="trackBy"
        @update-selections="updateSelectionsData"
        @filtering="filterStdUsn"
        ref="selectionsRef"
      ></selection-component>
    </div>
  </div>
</template>
<script>
import { service_paths, service_names } from "@/constants/Services";
import SelectionComponent from "./Selections";
export default {
  name: "student-option",
  components: {
    SelectionComponent
  },
  props: ["data", "hasCheckBox"],
  data() {
    return {
      selectedIndex: 0,
      displayField: "",
      trackBy: "",
      currentPath: "",
      dataList: [],
      gradeList: [],
      delayTime: null,
      query: {
        limit: 100
      }
    };
  },
  created() {
    this.getListOptions();
  },
  methods: {
    getListOptions() {
      switch (this.data.filter_by) {
        case "Class": {
          this.currentPath = service_paths.classes;
          this.displayField = "name";
          this.trackBy = "id";
          this.getDataList();
          break;
        }
        case "Term": {
          this.currentPath = service_paths.terms;
          this.displayField = "name";
          this.trackBy = "id";
          this.getDataList();
          break;
        }
        case "Program": {
          this.currentPath = service_paths.programs;
          this.displayField = "name";
          this.trackBy = "id";
          this.getDataList();
          break;
        }
        case "Student": {
          this.currentPath = `${service_paths.students}/filter?order_by=full_name`;
          this.displayField = "full_name";
          this.trackBy = "_id";
          this.query = Object.assign(
            {
              fields: ["full_name", "student_code"]
            },
            this.query
          );
          this.getDataList();
          break;
        }
        case "Grade": {
          this.getGrades();
          break;
        }
      }
      this.selectedIndex++;
    },
    setQuery(usnQuery) {
      if (this.data.filter_by === "Student") {
        return {
          search_key: usnQuery,
          limit: this.query.limit,
          fields: this.query.fields
        };
      }
      return {
        [`${this.displayField}__~`]: usnQuery,
        limit: this.query.limit
      };
    },
    filterStdUsn(usnQuery) {
      this.query = this.setQuery(usnQuery);

      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.$axios.get(this.currentPath, this.query).then(response => {
          this.dataList = response.data.data;
          const memorizedSelected = this.$refs.selectionsRef.getMemorizedSelected();
          memorizedSelected.forEach(studentSelected => {
            if (!this.dataList.includes(studentSelected))
              this.dataList.push(studentSelected);
          });
        });
      }, 200);
    },
    getDataList() {
      if (this.data.filter_by !== "Student")
        this.query = Object.assign({ limit: this.query.limit }, {});
      this.$axios.get(this.currentPath, this.query).then(response => {
        this.dataList = response.data.data;
      });
    },
    getGrades() {
      this.$axios
        .get(`${service_names.school}/grades`, { limit: this.query.limit })
        .then(response => {
          this.gradeList = response.data.data;
        });
    },
    updateSelectionsData(e) {
      this.data.selectedList = e;
    }
  }
};
</script>
